export function QuemSomos() {
  return (
    <section id="quem-somos" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-20 bg-dark">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold">
                Sobre nós
              </span>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Quem Somos
              </h2>
            </div>

            <p className="text-base sm:text-lg lg:text-xl text-white font-medium leading-relaxed">
              A Mansa Musa JH é uma empresa cultural especializada em:
            </p>

            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                <span className="text-gray-300 text-sm sm:text-base lg:text-lg">Execução de projetos culturais</span>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                <span className="text-gray-300 text-sm sm:text-base lg:text-lg">Captação via leis de incentivo</span>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                <span className="text-gray-300 text-sm sm:text-base lg:text-lg">Gestão de recursos públicos e privados</span>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                <span className="text-gray-300 text-sm sm:text-base lg:text-lg">Desenvolvimento territorial</span>
              </li>
              <li className="flex items-start gap-3 sm:gap-4">
                <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                <span className="text-gray-300 text-sm sm:text-base lg:text-lg">Produção de eventos, festivais e circuitos culturais</span>
              </li>
            </ul>

            <div className="pt-4 sm:pt-6 space-y-3 sm:space-y-4">
              <p className="text-white text-base sm:text-lg font-medium">
                Atuamos conectando cultura, organização e sustentabilidade econômica.
              </p>
              <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed">
                Nosso compromisso é transformar iniciativas culturais em estruturas sólidas, com transparência, impacto e resultado.
              </p>
            </div>
          </div>

          <div className="relative h-[400px] sm:h-[500px] lg:h-[600px] rounded-3xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/ddc6dbc53596691e38d04fbd711f3d87/344b89d25b5205e0eb3497ae9d5049bc.jpeg"
              alt="Equipe Mansa Musa JH"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}